import { render, staticRenderFns } from "./GalleryFeaturedCarousel.vue?vue&type=template&id=94464cee&scoped=true&"
import script from "./GalleryFeaturedCarousel.vue?vue&type=script&lang=js&"
export * from "./GalleryFeaturedCarousel.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFeaturedCarousel.vue?vue&type=style&index=0&id=94464cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94464cee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VImg,VRow,VSheet})
